<template>
    <div class="op-info-item">
        <small>{{ label }}</small>
        <strong>{{ displayValue }}</strong>
    </div>
</template>

<script>
export default {
    name: "OtherProceedingInfo",
    props: {
        label: { type: String, required: true },
        value: { type: [String, Number], default: null },
    },
    computed: {
        displayValue() {
            return this.value === null || this.value === undefined || this.value === "" ? "—" : this.value;
        },
    },
};
</script>
